__turbopack_context__.v({
  "blink": "Introduction-module-scss-module__5WCTVG__blink",
  "introduction": "Introduction-module-scss-module__5WCTVG__introduction",
});
